export default (state, action) => {
  let cache = state.cache;
  let status = state.status;
  let cacheIDs = state.items.slice();
  const currentTime = Date.now();

  switch(action.type) {

    case 'add':
    // console.log('add cache item - ' + action.id);
    cacheIDs.push(action.id);
    return {
      ...state,
      cache: {
        ...cache,
        [action.id]: {
          path: action.path,
          options: action.options,
          data: null,
          status: 0,
        }
      },
      items: cacheIDs,
    }

    case 'add_multiple':
    let addedIDs = action.items.map(setting => setting.id);
    // console.log('add multiple cache items', addedIDs);
    cacheIDs.push(...addedIDs);
    let cacheItems = {};
    let statusItems = {};
    action.items.forEach(cacheSetting =>
    cacheItems[cacheSetting.id] = {
      path: cacheSetting.path,
      options: cacheSetting.options,
      data: null,
      status: 0,
    })
    return{
      ...state,
      cache: {
        ...cache,
        ...cacheItems,
      },
      items: cacheIDs,
    }

    case 'remove':
    // console.log('remove cache item - ' + action.id);
    delete cache[action.id];
    cacheIDs = cacheIDs.filter(val => val !== action.id);
    return {...state, cache: cache, items: cacheIDs}

    case 'save_to_cache': {
      if (cache[action.id]) cache[action.id].data = action.data
      else cache[action.id] = {
        data: action.data,
        status: 10,
        id: action.id,
      };
      return {...state, cache};
    }

    case 'update_status':
    // console.log('update cache item status', action.id)
    cache[action.id].status = action.value;
    if (action.value === 0) cache[action.id].data = null;
    return {...state, cache}

    case 'update_status_multi':
    // console.log('update multiple cache items status', action.payload)
    action.payload.forEach(payload => cache[payload.id] = payload.value)
    return {...state, cache}

    case 'item_update':
    // console.log('update cache item', action.id, action.payload)
    let updatedCache = {
      ...cache,
      [action.id]: {
        ...cache[action.id],
        ...action.payload,
      }
    };
    // console.log(updatedCache)
    if (action.payload.data !== undefined) updatedCache[action.id].exp = currentTime + (5000 * 60); // 5 minute expiration
    return {
      ...state,
      cache: updatedCache,
    }

    // update pusher
    case 'mass_update':
    let updatedState = {...state};
    action.payload.forEach(updateObj => {
      updatedState[updateObj.id] = {
        ...updatedState[updateObj.id],
        ...updateObj.payload,
      }
    })
    return updatedState;

  }
}
